export enum GroupingBrandNokian {
  IconTyres = 'ikontyres',
  Nokian = 'nokian',
}

export enum GroupBrandSkad {
  Skad = 'skad',
  SkadPremium = 'skad-premium-1208',
}

export const groupingBrand = (brandCode: string): string => {
  switch (brandCode) {
    case GroupingBrandNokian.Nokian:
    case GroupingBrandNokian.IconTyres:
      return 'group-nokian';

    case GroupBrandSkad.Skad:
    case GroupBrandSkad.SkadPremium:
      return 'group-skad';

    default:
      return '';
  }
};
